// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	if ( document.getElementById( 'frontPageCarousel' ) ) {
		const slides = document.querySelectorAll( '#frontPageCarousel .carousel-item');
		const numberofSlides = slides.length;
		const randomSlideNumber = Math.floor( ( Math.random() * numberofSlides ) );

		slides[ randomSlideNumber ].classList.add( 'active' );

		const carousel = new bootstrap.Carousel( '#frontPageCarousel', {
			ride: 'carousel'
		});
	}

	// Make it possible to click on whole cards, not just their titles.
	// Inspired by https://css-tricks.com/block-links-the-search-for-a-perfect-solution/
	[].forEach.call( document.querySelectorAll( '.posts-cards' ), ( el ) => {
		el.addEventListener( 'click', function ( e ) {
			const card = e.target.closest( 'div.card' );
			if ( ! card ) return;
			if ( ! el.contains( card ) ) return;
			const isTextSelected = window.getSelection().toString();
			if (!isTextSelected) {
				const link = card.querySelector( '.card-title a' );
				link.click();
			}
		} );
	} );
} )();
